const Phone02 = ({ size, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "14"}
      height={size || "14"}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g id="phone-02">
        <path
          id="Solid"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.23883 0.582032H4.76053C4.45303 0.582022 4.18774 0.582013 3.96924 0.599865C3.73863 0.618707 3.50925 0.660308 3.28853 0.772771C2.95924 0.94055 2.69153 1.20827 2.52375 1.53755C2.41128 1.75827 2.36968 1.98765 2.35084 2.21827C2.33299 2.43676 2.333 2.70203 2.33301 3.00953V10.9879C2.333 11.2953 2.33299 11.5606 2.35084 11.7791C2.36968 12.0098 2.41128 12.2391 2.52375 12.4598C2.69153 12.7891 2.95924 13.0568 3.28853 13.2246C3.50925 13.3371 3.73863 13.3787 3.96924 13.3975C4.18774 13.4154 4.45301 13.4154 4.76051 13.4154H9.23884C9.54634 13.4154 9.81161 13.4154 10.0301 13.3975C10.2607 13.3787 10.4901 13.3371 10.7108 13.2246C11.0401 13.0568 11.3078 12.7891 11.4756 12.4598C11.5881 12.2391 11.6297 12.0098 11.6485 11.7791C11.6664 11.5606 11.6664 11.2954 11.6663 10.9879V3.00956C11.6664 2.70208 11.6664 2.43675 11.6485 2.21827C11.6297 1.98765 11.5881 1.75827 11.4756 1.53755C11.3078 1.20827 11.0401 0.94055 10.7108 0.772771C10.4901 0.660308 10.2607 0.618707 10.0301 0.599865C9.81161 0.582013 9.54632 0.582022 9.23883 0.582032ZM8.74968 1.7487V1.98203C8.74968 2.30873 8.74968 2.47208 8.6861 2.59686C8.63017 2.70662 8.54093 2.79586 8.43117 2.85179C8.30639 2.91537 8.14304 2.91537 7.81634 2.91537H6.18301C5.85631 2.91537 5.69296 2.91537 5.56818 2.85179C5.45842 2.79586 5.36918 2.70662 5.31325 2.59686C5.24968 2.47208 5.24968 2.30873 5.24968 1.98203V1.7487H8.74968Z"
          fill={color || "#697777"}
        />
      </g>
    </svg>
  );
};

export default Phone02;
